import { useQuery } from "@tanstack/react-query";
import React from "react";
import Project from "../Project/Project";

const Projects = () => {
  const { data: projects = [] } = useQuery({
    queryKey: ["projects"],
    queryFn: async () => {
      const res = await fetch("project.json");
      const data = await res.json();
      return data;
    },
  });
  return (
    <div id="project" className="w-10/12 mx-auto mt-32 mb-56">
      <div className="flex items-center mb-10">
        <span className="text-primary font-mono text-xl">03.</span>
        <h2 className="px-5 text-secondary font-bold text-2xl">
          FEATURED PROJECTS
        </h2>
        <hr className="w-2/6 border-gray-800 lg:block hidden" />
      </div>
      <div className="grid lg:grid-cols-3 gap-6">
        {projects.map((project) => (
          <Project key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
